import type { KeywordDefinition } from 'ajv';
import { NumberProperty } from 'shared';

const removeStartHyphenOrPlus = (numberValue: string): string => {
  if (numberValue.startsWith('-')) {
    return numberValue.substring(1);
  }
  if (numberValue.startsWith('+')) {
    return numberValue.substring(1);
  }
  return numberValue;
};

const removeFirstPeriod = (numberValue: string): string => {
  if (numberValue.includes('.')) {
    return numberValue.replace('.', '');
  }
  return numberValue;
};

const stringForDigitsValidation = (numberValue: string): string => {
  return removeFirstPeriod(removeStartHyphenOrPlus(numberValue));
};

const startsWithDecimalPoint = (numberValue: string): boolean => {
  return /^\./.test(numberValue);
};

const isNumeric = (numberValue: string): boolean => {
  return (
    numberValue !== '' &&
    !startsWithDecimalPoint(numberValue) &&
    !isNaN(Number(numberValue))
  );
};

export const digitsRange: KeywordDefinition = {
  keyword: 'digitsRange',
  type: 'string',
  validate(schema: NumberProperty['digitsRange'], data: string) {
    if (schema == null) {
      return true;
    }
    // data が空文字 or 数値として不正な場合(+, -, . のみが入力された場合も不正扱い)は 桁数チェック成功扱いでチェックはせずに抜ける
    // see: https://gitlab.dev-internal.crmstyle.com/synergy/newt/form/portal/-/issues/4390
    if (!isNumeric(data)) {
      return true;
    }
    const convertedValue = stringForDigitsValidation(data);
    if (schema.min != null && convertedValue.length < schema.min) {
      return false;
    }
    if (schema.max != null && convertedValue.length > schema.max) {
      return false;
    }
    return true;
  },
};
